
const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-bus-line',
      category: 'MOBILITÉ',
      title: 'Transports & Déplacements',
      description: 'Accédez facilement aux solutions de transport adaptées à vos besoins quotidiens : transports en commun, covoiturage, vélos partagés et services de mobilité douce.',
      benefits: [
        'Abonnements préférentiels',
        'Solutions de covoiturage local',
        'Vélos et trottinettes partagés',
        'Accompagnement mobilité',
      ],
    },
    {
      icon: 'ri-wheelchair-line',
      category: 'ACCESSIBILITÉ',
      title: 'Mobilité Réduite',
      description: 'Des aides et services dédiés pour faciliter vos déplacements et votre autonomie au quotidien, avec un accompagnement personnalisé.',
      benefits: [
        'Transport adapté PMR',
        'Aides financières disponibles',
        'Aménagement du domicile',
        'Accompagnement personnalisé',
      ],
    },
    {
      icon: 'ri-hand-heart-line',
      category: 'SOCIAL',
      title: 'Insertion Sociale',
      description: 'Bénéficiez d\'un accompagnement sur mesure pour votre insertion professionnelle et sociale, avec accès à des formations et un réseau local solidaire.',
      benefits: [
        'Formations qualifiantes',
        'Accompagnement emploi',
        'Réseau associatif local',
        'Aide à la réinsertion',
      ],
    },
    {
      icon: 'ri-home-heart-line',
      category: 'LOGEMENT',
      title: 'Immobilier & Logement',
      description: 'Trouvez les solutions adaptées à votre projet immobilier : location, accession à la propriété, aides au logement et accompagnement administratif.',
      benefits: [
        'Aides au logement',
        'Accès logement social',
        'Prêts avantageux',
        'Conseil juridique',
      ],
    },
    {
      icon: 'ri-car-line',
      category: 'AUTOMOBILE',
      title: 'Solutions Automobile',
      description: 'Accédez à des solutions pour l\'achat, l\'entretien et le financement de votre véhicule, avec des partenaires locaux de confiance.',
      benefits: [
        'Primes à la conversion',
        'Garages partenaires',
        'Financement facilité',
        'Assurance avantageuse',
      ],
    },
    {
      icon: 'ri-graduation-cap-line',
      category: 'ÉDUCATION',
      title: 'Éducation & Formation',
      description: 'Profitez d\'un large éventail de formations et d\'accompagnements éducatifs pour tous les âges, du soutien scolaire à la formation professionnelle.',
      benefits: [
        'Soutien scolaire gratuit',
        'Formations professionnelles',
        'Bourses d\'études',
        'Orientation personnalisée',
      ],
    },
    {
      icon: 'ri-restaurant-line',
      category: 'ALIMENTATION',
      title: 'Alimentation & Circuits Courts',
      description: 'Découvrez les producteurs locaux et les circuits courts de votre agglomération pour une alimentation saine, locale et accessible.',
      benefits: [
        'Marchés de producteurs',
        'Paniers bio locaux',
        'Aide alimentaire',
        'Ateliers cuisine',
      ],
    },
    {
      icon: 'ri-heart-pulse-line',
      category: 'SANTÉ',
      title: 'Santé & Soins',
      description: 'Accédez aux professionnels de santé et aux structures de soins de votre territoire, avec un accompagnement dans vos démarches administratives.',
      benefits: [
        'Centres de santé',
        'Aide complémentaire santé',
        'Téléconsultation',
        'Prévention santé',
      ],
    },
    {
      icon: 'ri-football-line',
      category: 'SPORT & LOISIRS',
      title: 'Sport & Associations',
      description: 'Rejoignez les clubs sportifs et associations de votre agglomération pour pratiquer une activité, créer du lien social et vous épanouir.',
      benefits: [
        'Clubs sportifs locaux',
        'Tarifs préférentiels',
        'Événements communautaires',
        'Vie associative active',
      ],
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour Vous
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Un accompagnement complet dans tous les domaines de votre vie quotidienne
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-gray-light rounded-2xl p-6 md:p-10 hover:border-primary-light transition-all duration-300 hover:shadow-lg"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mb-4 md:mb-5">
                <i className={`${service.icon} text-3xl md:text-4xl text-primary`}></i>
              </div>
              <div className="text-xs text-primary-light font-semibold tracking-wider mb-2 md:mb-3">
                {service.category}
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-primary-dark mb-3 md:mb-4">
                {service.title}
              </h3>
              <p className="text-sm md:text-base text-gray-dark leading-relaxed mb-5 md:mb-6">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-xs md:text-sm text-gray-dark">
                    <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
